import React, { createContext, useContext } from 'react';

const SegmentContext = createContext(null);

export const useSegmentContext = () => useContext(SegmentContext);

export const SegmentProvider = ({ children, selectedArc }) => (
  <SegmentContext.Provider value={selectedArc}>{children}</SegmentContext.Provider>
);
